export enum TpETLObjectTypes {
  TABLE = 'table',
  TEXT = 'text',
  MATRIX = 'matrix',
}

export function isTpETLObjectType(type: string): type is TpETLObjectTypes {
  return Object.values(TpETLObjectTypes).includes(type as TpETLObjectTypes);
}

export interface TpETLTableColumn {
  identifier: string;
  name: string;
  dataType: string;
  description?: string;
}

export interface TpETLInputTableColumn extends TpETLTableColumn {
  required: boolean;
}

export interface TpDataObjectBase {
  type: TpETLObjectTypes;
}

// ************************ ALL DATA TYPES *************************

export interface TpDataObjectText extends TpDataObjectBase {
  type: TpETLObjectTypes.TEXT;
}

export interface TpDataObjectTable extends TpDataObjectBase {
  type: TpETLObjectTypes.TABLE;
  columns: TpETLTableColumn[];
}

export interface TpDataObjectMatrix extends TpDataObjectBase {
  type: TpETLObjectTypes.MATRIX;
  obsMetadataColumns: TpETLTableColumn[];
  featureMetadataColumns: TpETLTableColumn[];
  linkColumnId?: string; // column that links the two tables together
}

export type TpMatrixColumnType = 'observations' | 'features';

// Discriminated union type for all data objects
export type TpDataObject = TpDataObjectText | TpDataObjectTable | TpDataObjectMatrix;

// ************************ SPECIFIC FOR INPUTS *************************

export interface TpDataObjectInputTable extends TpDataObjectBase {
  type: TpETLObjectTypes.TABLE;
  columns: TpETLInputTableColumn[];
}

export interface TpDataObjectInputMatrix extends TpDataObjectBase {
  type: TpETLObjectTypes.MATRIX;
  obsMetadataColumns: TpETLInputTableColumn[];
  featureMetadataColumns: TpETLInputTableColumn[];
  linkColumnId?: string; // column that links the two tables together
}

// Discriminated union type for input data objects
export type TpDataObjectInput = TpDataObjectInputTable | TpDataObjectInputMatrix | TpDataObjectText;
